import ConnectyCube from 'connectycube'
import appConfig from '../appConfig.json'
import User from '../models/user'
import store from '../store'
import { setCurrentUser } from '../actions/currentUser'
import { getImageLinkFromUID } from '../helpers/file'
import { LogOut } from '../reducers/index'
import * as constVal from '../constant';
import profile_photo_static from '../assets/stillhoute.png';

class AuthService {
  static CURRENT_USER_SESSION_KEY = 'CURRENT_USER_SESSION_KEY'
  static DEVICE_TOKEN_KEY = 'DEVICE_TOKEN_KEY'

  async init() {
    await ConnectyCube.init(...appConfig.connectyCubeConfig)
    return this.autologin()
  }

  async autologin() {
    const checkUserSessionFromStore = await this.getUserSession()
    if (checkUserSessionFromStore) {
      const data = JSON.parse(checkUserSessionFromStore)
      await this.signIn({ login: data.login, password: data.password })
      return 'home'
    } else { return 'auth' }
  }

  async signIn(params) {
    const session = await ConnectyCube.createSession(params)
    const currentUser = new User(session.user)

    let profile_photo= '';
    await fetch(constVal.base_url+'/get_profile.php?dialog_userlogin='+params.login)
      .then(res => res.json())
      .then((responseJson) => {
        if(responseJson != '' && responseJson != null)
          profile_photo = constVal.base_url2+'/'+responseJson;
      }).catch((error) => {
        console.error(error);
    });
    if(profile_photo == '')  
    profile_photo = profile_photo_static;

    profile_photo = profile_photo.replace(/ /g, '%20')
    // session.user.avatar = getImageLinkFromUID(session.user.avatar)
    session.user.avatar = profile_photo;
    // work around
    console.log(profile_photo, "profile_photoprofile_photo");
    session.user.full_name = session.user.login
    store.dispatch(setCurrentUser(session))
    const customSession = Object.assign({}, currentUser, { password: params.password })
    this.setUserSession(customSession)
    this.connect(customSession.id, customSession.password)
  }

  async signUp(params) {
    await ConnectyCube.createSession()
    await ConnectyCube.users.signup(params)
    return this.signIn(params)
  }

  async connect(userId, password) {
    await ConnectyCube.chat.connect({ userId, password })
  }

  setUserSession(userSession) {
    return localStorage.setItem(AuthService.CURRENT_USER_SESSION_KEY, JSON.stringify(userSession))
  }

  getUserSession() {
    return localStorage.getItem(AuthService.CURRENT_USER_SESSION_KEY)
  }

  async logout() {
    localStorage.clear()
    await ConnectyCube.logout()
    store.dispatch(LogOut())
  }


}

const authService = new AuthService()

Object.freeze(authService)

export default authService